export const PERIODS = {
  MONTHLY: 'monthly',
  LIFE_LONG: 'life_long',
  BALANCE: 'balance',
};

export const SKUS = {
  AI_RECEPTIONIST_CHAT: 'ai_receptionist_chat',
  AI_CREDIT: 'ai_credit',
  AI_VOICE_CREDIT: 'ai_voice_credit',
  SMS: 'sms',
};

export const COUNTABLE_SKUS = [
  SKUS.AI_RECEPTIONIST_CHAT,
  SKUS.AI_CREDIT,
  SKUS.AI_VOICE_CREDIT,
  SKUS.SMS,
];

export const SMS_FEATURE = 'sms_enabled';

export const PAYMENT_TYPES = {
  SINGLE_CHARGE: 'single_charge',
};

const NON_BILLABLE_PAYMENT_TYPES = ['free', 'bundle', 'external', 'external_single_charge'];

const COUNTABLE_ICONS = {
  [SKUS.AI_RECEPTIONIST_CHAT]: 'icon-conversation',
  [SKUS.AI_CREDIT]: 'icon-AI-Sparkles',
  [SKUS.AI_VOICE_CREDIT]: 'icon-Mic',
  [SKUS.SMS]: 'icon-Inbox_POV',
};

const DEFAULT_ICON = 'icon-AI-Sparkles';

export const iconFor = (sku) => COUNTABLE_ICONS[sku] || DEFAULT_ICON;
export const nameKeyFor = (sku) => `usage.countables.${sku}.name`;
export const isSingleCharge = (offering) => offering?.payment_type === PAYMENT_TYPES.SINGLE_CHARGE;
export const isPurchasable = (offering) => !NON_BILLABLE_PAYMENT_TYPES
  .includes(offering?.payment_type);
